import { trimJoinedStringWhitespace, withDefault } from '../../core/util';
import { maskSsnForDisplay } from '../PersonalInformationSection/util';

export const jointOwnerLine1 = owner => {
  const fullName = `${owner?.name?.firstName} ${withDefault(
    owner?.name?.middleName,
    ''
  )} ${owner?.name?.lastName}`;
  return [
    trimJoinedStringWhitespace(fullName),
    owner?.residentialAddress?.street1,
    owner?.residentialAddress?.city,
    owner?.residentialAddress?.state,
    owner?.residentialAddress?.zip
  ].join(' / ');
};

export const jointOwnerLine2 = owner => {
  return [
    owner?.dob,
    maskSsnForDisplay(owner?.taxID),
    {
      US_CITIZEN: 'U.S. Citizen',
      RESIDENT_ALIEN: 'U.S. Resident Alien'
    }[owner.citizenship] || owner.citizenship
  ].join(' / ');
};
